import React from 'react';
import PropTypes from 'prop-types';
import { Label } from '../index';

import './index.scss';

export default function Modal({
  style, className, open, title, onClose, children
}) {
  return (
    <div className={`modalDialog ${className} ${open ? 'opened' : ''}`} style={style}>
      <Label type="title">{title}</Label>
      <button className="btn-close" onClick={onClose}>
        <i className="material-icons">close</i>
      </button>
      {children}
    </div>
  );
}

Modal.propTypes = {
  style: PropTypes.shape(),
  title: PropTypes.string,
  className: PropTypes.string,
  open: PropTypes.bool,
  children: PropTypes.node.isRequired,
  onClose: PropTypes.func.isRequired,
};

Modal.defaultProps = {
  style: {},
  className: '',
  open: false,
  title: '',
};
